// 滚动动画指令，当元素进入视口时添加动画类，实现滚动动画效果
const animateOnScroll = {
  inserted: (el, binding) => {
    const animationClass = binding.value || 'fade-up'
    el.classList.add('animate-on-scroll', animationClass)

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          el.classList.add('animate-in')
          observer.unobserve(el)
        }
      })
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    })

    observer.observe(el)
  }
}

export default animateOnScroll
